import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Error from '../Pages/Error';

// Check if a path is a valid route
const isValidRoute = (pathToCheck) => {
  const validRoutes = [
    '/tr', '/tr/', '/en', '/en/',
    '/tr/home-tour', '/en/home-tour',
    '/tr/home-agency', '/en/home-agency',
    '/tr/home-yacht', '/en/home-yacht',
    '/tr/about', '/en/about',
    '/tr/destination', '/en/destination',
    '/tr/service', '/en/service',
    '/tr/activities', '/en/activities',
    '/tr/activities-details', '/en/activities-details',
    '/tr/shop', '/en/shop',
    '/tr/cart', '/en/cart',
    '/tr/checkout', '/en/checkout',
    '/tr/wishlist', '/en/wishlist',
    '/tr/gallery', '/en/gallery',
    '/tr/tour', '/en/tour',
    '/tr/tour-details', '/en/tour-details',
    '/tr/resort', '/en/resort',
    '/tr/tour-guide', '/en/tour-guide',
    '/tr/faq', '/en/faq',
    '/tr/error', '/en/error',
    '/tr/blog', '/en/blog',
    '/tr/contact', '/en/contact'
  ];
  
  // Check exact match
  if (validRoutes.includes(pathToCheck)) {
    return true;
  }
  
  // Check dynamic routes (with :id)
  const dynamicRoutes = [
    /^\/tr\/destination\/.+$/,
    /^\/en\/destination\/.+$/,
    /^\/tr\/service\/.+$/,
    /^\/en\/service\/.+$/,
    /^\/tr\/shop\/.+$/,
    /^\/en\/shop\/.+$/,
    /^\/tr\/resort\/.+$/,
    /^\/en\/resort\/.+$/,
    /^\/tr\/tour-guide\/.+$/,
    /^\/en\/tour-guide\/.+$/,
    /^\/tr\/blog\/.+$/,
    /^\/en\/blog\/.+$/
  ];
  
  return dynamicRoutes.some(pattern => pattern.test(pathToCheck));
};

function ErrorWrapper() {
  const location = useLocation();
  const [shouldShowError, setShouldShowError] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const path = location.pathname;
    const pathSegments = path.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];
    
    // If path has language prefix (tr or en), check if it's valid
    if (firstSegment === 'tr' || firstSegment === 'en') {
      const isValid = isValidRoute(path);
      if (isValid) {
        setShouldShowError(false);
        setIsChecking(false);
      } else {
        setShouldShowError(true);
        setIsChecking(false);
      }
    } else if (path === '/') {
      // Root path - don't show error, will be redirected
      setShouldShowError(false);
      setIsChecking(false);
    } else {
      // Path without language prefix - check if it would be valid with prefix
      const defaultLang = 'tr';
      const pathWithLang = `/${defaultLang}${path}`;
      const wouldBeValid = isValidRoute(pathWithLang);
      
      if (wouldBeValid) {
        setShouldShowError(false);
        setIsChecking(false);
      } else {
        setShouldShowError(true);
        setIsChecking(false);
      }
    }
  }, [location.pathname]);

  // Show loading while checking
  if (isChecking) {
    return (
      <div 
        className="preloader" 
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999
        }}
      >
        <div className="preloader-inner">
          <img src="/assets/img/logo.svg" alt="Haseki Sultan" style={{ maxWidth: '200px', animation: 'pulse 1.5s ease-in-out infinite' }} />
        </div>
        <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.7; transform: scale(0.95); }
          }
        `}</style>
      </div>
    );
  }

  // Only show error if path is truly invalid
  if (shouldShowError) {
    return <Error />;
  }

  // Path is being redirected, show nothing (or loading)
  return null;
}

export default ErrorWrapper;

